import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { Box, MenuItem, ListItemIcon, Divider } from '@mui/material';

import HomepageIcon from 'components/Icons/HomepageIcon';
import UserIcon from 'components/Icons/UserIcon';
import SummaryIcon from 'components/Icons/SummaryIcon';
import CareNetworkIcon from 'components/Icons/CareNetworkIcon';
import SignOutIcon from 'components/Icons/SignOutIcon';
import { useProfileImage } from 'context/ProfileImageContext';
import useCurrentRoute from 'hooks/useCurrentRoute';
import { useGetPersonAndAttributes } from 'hooks/useGetPersonAndAttributes';
import { useLogout } from 'hooks/useLogout';
import Logo from 'images/adpkd-registry-logo.svg';
import DefaultProfileAvatar from 'images/DefaultProfileAvatar.png';
import { getFullName } from 'utils/person';
import {
  HeaderWrapper,
  UserName,
  StyledAngle,
  UserProfileMenuToggleButton,
  StyledMenu,
  StyledListItemText,
} from './styles';

export const Header = () => {
  const navigate = useNavigate();
  const { path } = useCurrentRoute();
  const { handleLogout } = useLogout();
  const { person } = useGetPersonAndAttributes();
  const { profileImageUrl, headerImageUrl } = useProfileImage();
  // States
  const [anchorEl, setAnchorEl] = useState(null);

  // Handlers
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleMenuClick = (item) => {
    handleClose();
    return item.to === '/sign-in' ? handleLogout() : navigate(item.to);
  };

  const open = Boolean(anchorEl);
  const headerItems = [
    {
      title : (
        <StyledListItemText
          isActive={path === '/homepage'}>
          Homepage
        </StyledListItemText>
      ),
      to   : '/homepage',
      icon : <HomepageIcon
        isActive={path === '/homepage'}
      />,
    },
    {
      title : (
        <StyledListItemText
          isActive={path === '/my-account'}>
          My Account
        </StyledListItemText>
      ),
      to   : '/my-account',
      icon : <UserIcon
        isActive={path === '/my-account'}
      />,
    },
    {
      title : (
        <StyledListItemText
          isActive={path === '/care-summary'}>
          Care Summary
        </StyledListItemText>
      ),
      to   : '/care-summary',
      icon : <SummaryIcon
        isActive={path === '/care-summary'}
      />,
    },
    {
      title : (
        <StyledListItemText
          isActive={path === '/my-care-network'}>
          My Care Network
        </StyledListItemText>
      ),
      to   : '/my-care-network',
      icon : <CareNetworkIcon
        isActive={path === '/my-care-network'}
      />,
    },
    {
      title : <StyledListItemText>Sign Out</StyledListItemText>,
      to    : '/sign-in',
      icon  : <SignOutIcon />,
    },
  ];

  return (
    <HeaderWrapper
      sx={{
        display : { xs: 'flex' },
        padding : { xs: 1, sm: '10px 50px', md: '14px 78px' },
      }}>
      <Box
        component='img'
        sx={{
          height : { xs: '50%', md: '100%' },
        }}
        src={Logo}
        alt='pkd logo'
      />
      <Box>
        <UserProfileMenuToggleButton
          onClick={handleClick}>
          <UserName
            variant='pl3' color='primary.gray6'>
            {getFullName(person)}
          </UserName>
          {profileImageUrl !== ''
            ? (
              <img
                height='40'
                width='40'
                src={`${headerImageUrl}`}
                alt='user avatar'
                style={{ border: '1px solid gray', borderRadius: '50%' }}
              />
            )
            : (
              <img
                height='40'
                width='40'
                src={DefaultProfileAvatar}
                alt='default avatar'
                style={{ border: '1px solid gray', borderRadius: '50%' }}
              />
            )}
          <StyledAngle
            isMenuOpen={open}
          />
        </UserProfileMenuToggleButton>
        <StyledMenu
          id='user-profile-menu'
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby' : 'basic-button',
          }}
          anchorOrigin={{
            vertical   : 'bottom',
            horizontal : 'left',
          }}>
          {headerItems.map((item, index) => (
            <Box
              key={item.to}>
              <MenuItem
                onClick={() => handleMenuClick(item)}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                {item.title}
              </MenuItem>
              {index !== headerItems.length - 1 && <Divider />}
            </Box>
          ))}
        </StyledMenu>
      </Box>
    </HeaderWrapper>
  );
};
